// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?id=" + {"120":"1f172e6549ebf670","494":"28041a582eb21b35","856":"c452903c69329fed"}[chunkId] + "";
};